// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserDetails-containerWith-yiZ0_ {
    width: 100%;
    max-width: 1260px !important;
    margin: 0 auto;
}

.UserDetails-container-ZYfa8 {
    max-width: 100%;
}

/* Text - Start */

.UserDetails-subText-_K65q {
    color: var(--secondary-foreground);
    font-size: 14px;
}

/* Text - End */

/* Header */

.UserDetails-navigationLink-Pmik0 a {
    padding-right: 20px !important;
    padding-left: 20px !important;
    color: var(--primary-foreground) !important;
    font-size: 18px;
    border-bottom: 2px solid transparent;
}

.UserDetails-navigationLink-Pmik0 a:hover,
.UserDetails-navigationLink-Pmik0 a:focus,
.UserDetails-navigationLink-Pmik0 a:active {
    border-bottom: 2px solid var(--primary-foreground);
}

/* Header */

/* commonCss */

.UserDetails-noPadding-XxspJ {
    padding: 0;
}

.UserDetails-heading-fQ4mT {
    padding: 30px 0px 24px 0px;
    font-weight: 700;
    font-size: 24px;
    color: var(--primary-foreground);
}

.UserDetails-widthInner-vxpGy {
    margin: 0px auto 0px auto;
    border-radius: 4px;
    padding: 0px;
    margin: 0px 15px 30px;
}

.UserDetails-noMargin-VmObh {
    margin: 0;
}

.UserDetails-formControlInputTable-D6CLx {
    border: none;
    width: 100px;
    height: auto;
}

.UserDetails-backBtn-KCzl3 {
    margin-left: 15px;
    display: inline-block;
}

.UserDetails-backBtn-KCzl3:active,
.UserDetails-backBtn-KCzl3:hover,
.UserDetails-backBtn-KCzl3:focus {
    color: var(--primary-bg);
    text-decoration: none !important;
}

.UserDetails-textAlignRight-HFolC {
    text-align: right;
}

.UserDetails-displayInlineBlock-Uklwd {
    display: inline-block;
}

.UserDetails-displayBlock-nWlxd {
    display: block;
}

.UserDetails-countryCode-TlzcQ {
    width: 15%;
    vertical-align: top;
}

.UserDetails-vtrMiddle-GglUj {
    vertical-align: middle;
}

/* commonCss */

.UserDetails-editIcon-XNSMs {
    width: 100%;
    width: 15px;
    vertical-align: middle;
    margin-right: 3px;
}

.UserDetails-iconBtn-mXE8P,
.UserDetails-iconBtn-mXE8P:hover,
.UserDetails-iconBtn-mXE8P:focus {
    padding: 0 !important;
    background: transparent !important;
    color: var(--danger-action-color) !important;
    border: 0 !important;
    white-space: nowrap;
    font-size: 16px !important;
    text-decoration: unset !important;
    cursor: pointer;
}

.UserDetails-profileImg-hOmJn {
    width: 100%;
    height: auto;
    margin-bottom: 18px;
}

.UserDetails-profileImgSection-EpRgk {
    width: 100%;
    margin: 0 auto;
    padding: 30px;
    border-radius: 12px;
    border: 1px solid var(--primary-border);
    background: var(--primary-input-bg);

}

.UserDetails-profileImgWidth-CWW9v {
    margin: 0;
    max-width: 100% !important;
}

.UserDetails-searchInput-f1p5p {
    width: 100%;
    max-width: 320px;
}

.UserDetails-backgroundImg-rlzun {
    padding-top: 42%;
    background-repeat: no-repeat;
    background-size: contain;
    margin-bottom: 18px;
    border-radius: 4px;
    background-color: transparent;
    background-position: center;
    margin-top: 6px;
    border: 1px dashed var(--primary-border);
    border-radius: 12px;
}

/*******************Export CSV section start ******************/

.UserDetails-exportDisplay-obfzH {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    margin-bottom: 18px;
    gap: 18px;
    grid-gap: 18px;
}

.UserDetails-exportTextSection-BI7iq {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 12px;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
}

.UserDetails-exportText-DivzC {
    display: inline-block;
    padding-right: 5px;
}

.UserDetails-exportTextContainer-KpvhV {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    color: var(--primary-link-foreground) !important;
    text-decoration: unset !important;
    border-bottom: 1px solid var(--primary-link-foreground);
}

.UserDetails-vtrTextBottom-oPd9K {
    vertical-align: text-bottom;
}

.UserDetails-exportImg-YG325 {
    width: 100%;
    max-width: 14px;
    height: 14px;
    -o-object-fit: contain;
       object-fit: contain;
}

/*******************Export CSV section End ******************/

.UserDetails-noLink-SaY73,
.UserDetails-noLink-SaY73:hover {
    color: var(--primary-link-foreground) !important;
    cursor: pointer;
}

.UserDetails-singleCard-sfIFL {
    width: 500px;
    margin: 0 auto;
}

.UserDetails-defaultIcon-sjhdy {
    background-size: 50px;
}

.UserDetails-assignProviderSearchInput-Aa0cV {
    width: 100%;
    max-width: 324px;
}

.UserDetails-searchGroupContainer-lMbEu {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 12px;
    -webkit-box-flex: 1;
        -ms-flex-positive: 1;
            flex-grow: 1;
}

@media (max-width: 767px) {
    .UserDetails-searchGroupContainer-lMbEu {
        width: 100%;
    }

}

@media (max-width: 1199px) and (min-width: 1024px) {
  .UserDetails-widthInner-vxpGy {
    width: 100%;
    border-radius: 0;
    margin: 0 auto;
  }

  .UserDetails-aboutGrid-JkoM6 img {
    position: relative;
    top: -25px !important;
  }

  .UserDetails-responsiveView-dpShh {
    width: 100% !important;
    max-width: 175px !important;
  }

  .UserDetails-positionFive-XeZjd {
    top: 28% !important;
  }

  .UserDetails-positionTwo-M29jU {
    top: 28% !important;
  }

  .UserDetails-responsiveContentOne-Rlyuv {
    top: -50px !important;
  }

  .UserDetails-positionFour-x3kX0 {
    top: -50px !important;
  }

  .UserDetails-totalCss-CCYOh {
    width: 100% !important;
  }


}

@media (max-width: 1024px) {
  .UserDetails-navbar-expand-lg-cvTgM .UserDetails-navbar-toggler-mHQQd {
    display: block !important;
    position: absolute;
    top: 23px;
    right: 20px;
  }

  .UserDetails-profileImgSection-EpRgk {
    padding: 18px;
  }
}

@media (max-width: 1023px) and (min-width: 768px) {

  .UserDetails-navigationLink-Pmik0 a {
    color: var(--primary-foreground) !important;
  }

  .UserDetails-widthInner-vxpGy {
    width: 100%;
    border-radius: 0;
    margin: 0 auto;
  }

  .UserDetails-responsiveContentOne-Rlyuv {
    width: 300px !important;
    position: absolute !important;
    top: -42px !important;
    left: -5% !important;
  }

  .UserDetails-positionTwo-M29jU {
    top: 24% !important;
    left: -5% !important;
  }

  .UserDetails-positionThree-yMvgj {
    top: 70% !important;
    left: -5% !important;
  }

  .UserDetails-positionFour-x3kX0 {
    top: -42px !important;
    right: -5% !important;
  }

  .UserDetails-positionFive-XeZjd {
    top: 20% !important;
    right: -5% !important;
  }

  .UserDetails-positionSix-RI9HH {
    top: 70% !important;
    right: -5% !important;
  }

  .UserDetails-responsiveView-dpShh {
    width: 100% !important;
    max-width: 115px !important;
  }

  .UserDetails-aboutGrid-JkoM6 img {
    top: -1px !important;
  }

  .UserDetails-contentOne-rvMms h1 {
    font-size: 16px !important;
  }

  .UserDetails-contentOne-rvMms p {
    font-size: 12px !important;
  }


  .UserDetails-totalCss-CCYOh {
    width: 100% !important;
  }

  .UserDetails-padding-hBgun {
    padding: 0px 0 0 60px !important;
  }

  .UserDetails-singleCard-sfIFL {
    width: 100% !important;
  }

  .UserDetails-navigationLink-Pmik0 a:hover,
  .UserDetails-navigationLink-Pmik0 a:focus,
  .UserDetails-navigationLink-Pmik0 a:active {
    border-bottom: 2px solid transparent;
  }
}

@media screen and (max-width: 823px) {
  .UserDetails-navbar-collapse-yfz0F.UserDetails-show-offPv {
    right: 0% !important;
    top: 0 !important;
  }

  .UserDetails-navbar-collapse-yfz0F {
    position: fixed !important;
    height: 100vh !important;
    width: 100% !important;
    background: #fff !important;
    right: -100% !important;
    -webkit-transition: 0.5s !important;
    transition: 0.5s !important;
  }
}

@media (max-width: 767px) {
  .UserDetails-content-M4Y5W {
    float: none;
  }

  .UserDetails-mr-auto-kGRlE.UserDetails-navbar-nav-h5Xuw {
    padding-bottom: 80px !important;
  }

  .UserDetails-navigationLink-Pmik0 a {
    color: var(--primary-foreground) !important;
  }

  .UserDetails-footer-DVaWd {
    padding: 35px 0 0 15px;
  }

  .UserDetails-widthInner-vxpGy {
    width: 100%;
    margin: 0px auto 0 auto;
    border-radius: 0;
  }

  .UserDetails-responsiveNoPadding-t7AQi {
    padding: 0px !important;
  }

  .UserDetails-contentOne-rvMms {
    position: relative !important;
    text-align: left !important;
    width: auto !important;
    padding: 0px 15px !important;
  }

  .UserDetails-aboutContainer-Pzazz {
    padding: 30px 0 30px !important;
  }

  .UserDetails-noPosition-bi9l0 {
    left: 0 !important;
    right: 0 !important;
    top: 0 !important;
  }

  .UserDetails-mobimleImg-kf4zW {
    display: none !important;
  }

  .UserDetails-totalCss-CCYOh {
    width: 100% !important;
  }

  .UserDetails-imgWidth-u2sZ9 {
    padding: 18px !important;
  }

  .UserDetails-searchInput-f1p5p,
  .UserDetails-assignProviderSearchInput-Aa0cV {
    max-width: 100% !important;
  }

  .UserDetails-exportText-DivzC {
    display: inline-block;
  }

  .UserDetails-gridSystem-B6eBI {
    grid-template-columns: auto !important;
  }

  .UserDetails-padding-hBgun {
    padding: 52px 0 0 0 !important;
  }

  .UserDetails-heading-fQ4mT {
    padding: 30px 0 24px !important;
  }

  .UserDetails-singleCard-sfIFL {
    width: 100% !important;
  }

  .UserDetails-displayGrid-v0JOb {
    grid-template-columns: 100% !important;
    grid-gap: 12px;
  }

  .UserDetails-boxInner-Hc3C7 {
    padding: 35px 0 !important;
  }

  .UserDetails-navigationLink-Pmik0 a:hover,
  .UserDetails-navigationLink-Pmik0 a:focus,
  .UserDetails-navigationLink-Pmik0 a:active {
    border-bottom: 2px solid transparent;
  }
}

@media (max-width: 480px) and (min-width: 320px) {
  .UserDetails-whiteDropdown-DSmsm select {
    width: 120px !important;
  }
}

.UserDetails-displayGrid-v0JOb {
    display: grid;
    grid-template-columns: 25% 48% 27%;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
}

.UserDetails-containerWidth-z_98z {
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
    padding: 18px 15px 15px;
    margin-bottom: 40px;
    background: var(--secondary-gray-bg);
    border-radius: 10px;
    border: 1px solid var(--primary-border);

}

.UserDetails-icon-Wd6tt {
    width: 95px;
    height: 95px;
    background-position: 50%;
    background-size: cover;
    display: inline-block;
    border-radius: 50%;
    position: relative;
}

.UserDetails-centerChatIcon-xS9YO {
    height: 62px;
    width: 62px;
    margin-left: -28px;
    margin-right: -28px;
    position: relative;
    z-index: 1;
    text-align: center;
    display: inline-block;
    vertical-align: top;
}

.UserDetails-iconBG-Jwo0B {
    border-radius: 50%;
    text-align: center;
    height: 62px;
    width: 62px;
}

.UserDetails-iconBG-Jwo0B img {
    width: 75%;
    display: inline-block;
    padding: 25px 0 0 0
}

.UserDetails-textAlignCenter-HXKtK {
    text-align: center;
}

.UserDetails-textAlignRight-HFolC {
    text-align: right;
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.UserDetails-textAlignLeft-X8HLb {
    text-align: left;
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.UserDetails-batchIcon-xmCRc {
    position: absolute;
    bottom: 2px;
    right: 1px;
    width: 26px;
}

.UserDetails-positionRelative-TZffw {
    position: relative;
}

@media (max-width: 1199px) and (min-width: 768px) {
    .UserDetails-icon-Wd6tt {
        width: 70px;
        height: 70px;
    }

    .UserDetails-batchIcon-xmCRc {
        bottom: -22px;
        right: -6px;
        width: 26px;
    }

    .UserDetails-iconBG-Jwo0B img {
        padding: 12px 0 0 0;
    }
}

@media screen and (max-width: 767px) {
    .UserDetails-hiddenXs-VZ5E1 {
        display: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Common.css","webpack://./src/components/responsive-common.css","webpack://./src/components/SiteAdmin/ChatMessages/UserDetails/UserDetails.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,4BAA4B;IAC5B,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA,iBAAiB;;AACjB;IACI,kCAAkC;IAClC,eAAe;AACnB;;AAEA,eAAe;;AAEf,WAAW;;AAEX;IACI,8BAA8B;IAC9B,6BAA6B;IAC7B,2CAA2C;IAC3C,eAAe;IACf,oCAAoC;AACxC;;AAEA;;;IAGI,kDAAkD;AACtD;;AAEA,WAAW;;AAEX,cAAc;;AACd;IACI,UAAU;AACd;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;;;IAGI,wBAAwB;IACxB,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,cAAc;;AAEd;IACI,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;;;IAGI,qBAAqB;IACrB,kCAAkC;IAClC,4CAA4C;IAC5C,oBAAoB;IACpB,mBAAmB;IACnB,0BAA0B;IAC1B,iCAAiC;IACjC,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uCAAuC;IACvC,mCAAmC;;AAEvC;;AAEA;IACI,SAAS;IACT,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,4BAA4B;IAC5B,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,6BAA6B;IAC7B,2BAA2B;IAC3B,eAAe;IACf,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA,+DAA+D;;AAC/D;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,mBAAe;QAAf,eAAe;IACf,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;IACT,mBAAe;QAAf,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,gDAAgD;IAChD,iCAAiC;IACjC,uDAAuD;AAC3D;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,sBAAmB;OAAnB,mBAAmB;AACvB;;AAEA,6DAA6D;;AAC7D;;IAEI,gDAAgD;IAChD,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;IACT,mBAAY;QAAZ,oBAAY;YAAZ,YAAY;AAChB;;AAEA;IACI;QACI,WAAW;IACf;;AAEJ;;AC1OA;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;;AAGF;;AAEA;EACE;IACE,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;;EAEE;IACE,2CAA2C;EAC7C;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,6BAA6B;IAC7B,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,qBAAqB;IACrB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;;EAGA;IACE,sBAAsB;EACxB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;;IAGE,oCAAoC;EACtC;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,wBAAwB;IACxB,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;IACvB,mCAA2B;IAA3B,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,6BAA6B;IAC7B,2BAA2B;IAC3B,sBAAsB;IACtB,4BAA4B;EAC9B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sCAAsC;IACtC,cAAc;EAChB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;IAGE,oCAAoC;EACtC;AACF;;AAGA;EACE;IACE,uBAAuB;EACzB;AACF;;ACzPA;IACI,aAAa;IACb,kCAAkC;IAClC,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,uBAAuB;IACvB,mBAAmB;IACnB,oCAAoC;IACpC,mBAAmB;IACnB,uCAAuC;;AAE3C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,sBAAsB;IACtB,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,UAAU;IACV,qBAAqB;IACrB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,WAAW;QACX,WAAW;IACf;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":[".containerWith {\n    width: 100%;\n    max-width: 1260px !important;\n    margin: 0 auto;\n}\n\n.container {\n    max-width: 100%;\n}\n\n/* Text - Start */\n.subText {\n    color: var(--secondary-foreground);\n    font-size: 14px;\n}\n\n/* Text - End */\n\n/* Header */\n\n.navigationLink a {\n    padding-right: 20px !important;\n    padding-left: 20px !important;\n    color: var(--primary-foreground) !important;\n    font-size: 18px;\n    border-bottom: 2px solid transparent;\n}\n\n.navigationLink a:hover,\n.navigationLink a:focus,\n.navigationLink a:active {\n    border-bottom: 2px solid var(--primary-foreground);\n}\n\n/* Header */\n\n/* commonCss */\n.noPadding {\n    padding: 0;\n}\n\n.heading {\n    padding: 30px 0px 24px 0px;\n    font-weight: 700;\n    font-size: 24px;\n    color: var(--primary-foreground);\n}\n\n.widthInner {\n    margin: 0px auto 0px auto;\n    border-radius: 4px;\n    padding: 0px;\n    margin: 0px 15px 30px;\n}\n\n.noMargin {\n    margin: 0;\n}\n\n.formControlInputTable {\n    border: none;\n    width: 100px;\n    height: auto;\n}\n\n.backBtn {\n    margin-left: 15px;\n    display: inline-block;\n}\n\n.backBtn:active,\n.backBtn:hover,\n.backBtn:focus {\n    color: var(--primary-bg);\n    text-decoration: none !important;\n}\n\n.textAlignRight {\n    text-align: right;\n}\n\n.displayInlineBlock {\n    display: inline-block;\n}\n\n.displayBlock {\n    display: block;\n}\n\n.countryCode {\n    width: 15%;\n    vertical-align: top;\n}\n\n.vtrMiddle {\n    vertical-align: middle;\n}\n\n/* commonCss */\n\n.editIcon {\n    width: 100%;\n    width: 15px;\n    vertical-align: middle;\n    margin-right: 3px;\n}\n\n.iconBtn,\n.iconBtn:hover,\n.iconBtn:focus {\n    padding: 0 !important;\n    background: transparent !important;\n    color: var(--danger-action-color) !important;\n    border: 0 !important;\n    white-space: nowrap;\n    font-size: 16px !important;\n    text-decoration: unset !important;\n    cursor: pointer;\n}\n\n.profileImg {\n    width: 100%;\n    height: auto;\n    margin-bottom: 18px;\n}\n\n.profileImgSection {\n    width: 100%;\n    margin: 0 auto;\n    padding: 30px;\n    border-radius: 12px;\n    border: 1px solid var(--primary-border);\n    background: var(--primary-input-bg);\n\n}\n\n.profileImgWidth {\n    margin: 0;\n    max-width: 100% !important;\n}\n\n.searchInput {\n    width: 100%;\n    max-width: 320px;\n}\n\n.backgroundImg {\n    padding-top: 42%;\n    background-repeat: no-repeat;\n    background-size: contain;\n    margin-bottom: 18px;\n    border-radius: 4px;\n    background-color: transparent;\n    background-position: center;\n    margin-top: 6px;\n    border: 1px dashed var(--primary-border);\n    border-radius: 12px;\n}\n\n/*******************Export CSV section start ******************/\n.exportDisplay {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    align-items: center;\n    margin-bottom: 18px;\n    gap: 18px;\n    grid-gap: 18px;\n}\n\n.exportTextSection {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.exportText {\n    display: inline-block;\n    padding-right: 5px;\n}\n\n.exportTextContainer {\n    display: flex;\n    align-items: center;\n    color: var(--primary-link-foreground) !important;\n    text-decoration: unset !important;\n    border-bottom: 1px solid var(--primary-link-foreground);\n}\n\n.vtrTextBottom {\n    vertical-align: text-bottom;\n}\n\n.exportImg {\n    width: 100%;\n    max-width: 14px;\n    height: 14px;\n    object-fit: contain;\n}\n\n/*******************Export CSV section End ******************/\n.noLink,\n.noLink:hover {\n    color: var(--primary-link-foreground) !important;\n    cursor: pointer;\n}\n\n.singleCard {\n    width: 500px;\n    margin: 0 auto;\n}\n\n.defaultIcon {\n    background-size: 50px;\n}\n\n.assignProviderSearchInput {\n    width: 100%;\n    max-width: 324px;\n}\n\n.searchGroupContainer {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-grow: 1;\n}\n\n@media (max-width: 767px) {\n    .searchGroupContainer {\n        width: 100%;\n    }\n\n}","@media (max-width: 1199px) and (min-width: 1024px) {\n  .widthInner {\n    width: 100%;\n    border-radius: 0;\n    margin: 0 auto;\n  }\n\n  .aboutGrid img {\n    position: relative;\n    top: -25px !important;\n  }\n\n  .responsiveView {\n    width: 100% !important;\n    max-width: 175px !important;\n  }\n\n  .positionFive {\n    top: 28% !important;\n  }\n\n  .positionTwo {\n    top: 28% !important;\n  }\n\n  .responsiveContentOne {\n    top: -50px !important;\n  }\n\n  .positionFour {\n    top: -50px !important;\n  }\n\n  .totalCss {\n    width: 100% !important;\n  }\n\n\n}\n\n@media (max-width: 1024px) {\n  .navbar-expand-lg .navbar-toggler {\n    display: block !important;\n    position: absolute;\n    top: 23px;\n    right: 20px;\n  }\n\n  .profileImgSection {\n    padding: 18px;\n  }\n}\n\n@media (max-width: 1023px) and (min-width: 768px) {\n\n  .navigationLink a {\n    color: var(--primary-foreground) !important;\n  }\n\n  .widthInner {\n    width: 100%;\n    border-radius: 0;\n    margin: 0 auto;\n  }\n\n  .responsiveContentOne {\n    width: 300px !important;\n    position: absolute !important;\n    top: -42px !important;\n    left: -5% !important;\n  }\n\n  .positionTwo {\n    top: 24% !important;\n    left: -5% !important;\n  }\n\n  .positionThree {\n    top: 70% !important;\n    left: -5% !important;\n  }\n\n  .positionFour {\n    top: -42px !important;\n    right: -5% !important;\n  }\n\n  .positionFive {\n    top: 20% !important;\n    right: -5% !important;\n  }\n\n  .positionSix {\n    top: 70% !important;\n    right: -5% !important;\n  }\n\n  .responsiveView {\n    width: 100% !important;\n    max-width: 115px !important;\n  }\n\n  .aboutGrid img {\n    top: -1px !important;\n  }\n\n  .contentOne h1 {\n    font-size: 16px !important;\n  }\n\n  .contentOne p {\n    font-size: 12px !important;\n  }\n\n\n  .totalCss {\n    width: 100% !important;\n  }\n\n  .padding {\n    padding: 0px 0 0 60px !important;\n  }\n\n  .singleCard {\n    width: 100% !important;\n  }\n\n  .navigationLink a:hover,\n  .navigationLink a:focus,\n  .navigationLink a:active {\n    border-bottom: 2px solid transparent;\n  }\n}\n\n@media screen and (max-width: 823px) {\n  .navbar-collapse.show {\n    right: 0% !important;\n    top: 0 !important;\n  }\n\n  .navbar-collapse {\n    position: fixed !important;\n    height: 100vh !important;\n    width: 100% !important;\n    background: #fff !important;\n    right: -100% !important;\n    transition: 0.5s !important;\n  }\n}\n\n@media (max-width: 767px) {\n  .content {\n    float: none;\n  }\n\n  .mr-auto.navbar-nav {\n    padding-bottom: 80px !important;\n  }\n\n  .navigationLink a {\n    color: var(--primary-foreground) !important;\n  }\n\n  .footer {\n    padding: 35px 0 0 15px;\n  }\n\n  .widthInner {\n    width: 100%;\n    margin: 0px auto 0 auto;\n    border-radius: 0;\n  }\n\n  .responsiveNoPadding {\n    padding: 0px !important;\n  }\n\n  .contentOne {\n    position: relative !important;\n    text-align: left !important;\n    width: auto !important;\n    padding: 0px 15px !important;\n  }\n\n  .aboutContainer {\n    padding: 30px 0 30px !important;\n  }\n\n  .noPosition {\n    left: 0 !important;\n    right: 0 !important;\n    top: 0 !important;\n  }\n\n  .mobimleImg {\n    display: none !important;\n  }\n\n  .totalCss {\n    width: 100% !important;\n  }\n\n  .imgWidth {\n    padding: 18px !important;\n  }\n\n  .searchInput,\n  .assignProviderSearchInput {\n    max-width: 100% !important;\n  }\n\n  .exportText {\n    display: inline-block;\n  }\n\n  .gridSystem {\n    grid-template-columns: auto !important;\n  }\n\n  .padding {\n    padding: 52px 0 0 0 !important;\n  }\n\n  .heading {\n    padding: 30px 0 24px !important;\n  }\n\n  .singleCard {\n    width: 100% !important;\n  }\n\n  .displayGrid {\n    grid-template-columns: 100% !important;\n    grid-gap: 12px;\n  }\n\n  .boxInner {\n    padding: 35px 0 !important;\n  }\n\n  .navigationLink a:hover,\n  .navigationLink a:focus,\n  .navigationLink a:active {\n    border-bottom: 2px solid transparent;\n  }\n}\n\n\n@media (max-width: 480px) and (min-width: 320px) {\n  .whiteDropdown select {\n    width: 120px !important;\n  }\n}","@import '../../../../components/Common.css';\n@import '../../../../components/responsive-common.css';\n\n.displayGrid {\n    display: grid;\n    grid-template-columns: 25% 48% 27%;\n    align-items: center;\n}\n\n.containerWidth {\n    width: 100%;\n    max-width: 800px;\n    margin: 0 auto;\n    padding: 18px 15px 15px;\n    margin-bottom: 40px;\n    background: var(--secondary-gray-bg);\n    border-radius: 10px;\n    border: 1px solid var(--primary-border);\n\n}\n\n.icon {\n    width: 95px;\n    height: 95px;\n    background-position: 50%;\n    background-size: cover;\n    display: inline-block;\n    border-radius: 50%;\n    position: relative;\n}\n\n.centerChatIcon {\n    height: 62px;\n    width: 62px;\n    margin-left: -28px;\n    margin-right: -28px;\n    position: relative;\n    z-index: 1;\n    text-align: center;\n    display: inline-block;\n    vertical-align: top;\n}\n\n.iconBG {\n    border-radius: 50%;\n    text-align: center;\n    height: 62px;\n    width: 62px;\n}\n\n.iconBG img {\n    width: 75%;\n    display: inline-block;\n    padding: 25px 0 0 0\n}\n\n.textAlignCenter {\n    text-align: center;\n}\n\n.textAlignRight {\n    text-align: right;\n    max-width: 200px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.textAlignLeft {\n    text-align: left;\n    max-width: 200px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.batchIcon {\n    position: absolute;\n    bottom: 2px;\n    right: 1px;\n    width: 26px;\n}\n\n.positionRelative {\n    position: relative;\n}\n\n@media (max-width: 1199px) and (min-width: 768px) {\n    .icon {\n        width: 70px;\n        height: 70px;\n    }\n\n    .batchIcon {\n        bottom: -22px;\n        right: -6px;\n        width: 26px;\n    }\n\n    .iconBG img {\n        padding: 12px 0 0 0;\n    }\n}\n\n@media screen and (max-width: 767px) {\n    .hiddenXs {\n        display: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerWith": `UserDetails-containerWith-yiZ0_`,
	"container": `UserDetails-container-ZYfa8`,
	"subText": `UserDetails-subText-_K65q`,
	"navigationLink": `UserDetails-navigationLink-Pmik0`,
	"noPadding": `UserDetails-noPadding-XxspJ`,
	"heading": `UserDetails-heading-fQ4mT`,
	"widthInner": `UserDetails-widthInner-vxpGy`,
	"noMargin": `UserDetails-noMargin-VmObh`,
	"formControlInputTable": `UserDetails-formControlInputTable-D6CLx`,
	"backBtn": `UserDetails-backBtn-KCzl3`,
	"textAlignRight": `UserDetails-textAlignRight-HFolC`,
	"displayInlineBlock": `UserDetails-displayInlineBlock-Uklwd`,
	"displayBlock": `UserDetails-displayBlock-nWlxd`,
	"countryCode": `UserDetails-countryCode-TlzcQ`,
	"vtrMiddle": `UserDetails-vtrMiddle-GglUj`,
	"editIcon": `UserDetails-editIcon-XNSMs`,
	"iconBtn": `UserDetails-iconBtn-mXE8P`,
	"profileImg": `UserDetails-profileImg-hOmJn`,
	"profileImgSection": `UserDetails-profileImgSection-EpRgk`,
	"profileImgWidth": `UserDetails-profileImgWidth-CWW9v`,
	"searchInput": `UserDetails-searchInput-f1p5p`,
	"backgroundImg": `UserDetails-backgroundImg-rlzun`,
	"exportDisplay": `UserDetails-exportDisplay-obfzH`,
	"exportTextSection": `UserDetails-exportTextSection-BI7iq`,
	"exportText": `UserDetails-exportText-DivzC`,
	"exportTextContainer": `UserDetails-exportTextContainer-KpvhV`,
	"vtrTextBottom": `UserDetails-vtrTextBottom-oPd9K`,
	"exportImg": `UserDetails-exportImg-YG325`,
	"noLink": `UserDetails-noLink-SaY73`,
	"singleCard": `UserDetails-singleCard-sfIFL`,
	"defaultIcon": `UserDetails-defaultIcon-sjhdy`,
	"assignProviderSearchInput": `UserDetails-assignProviderSearchInput-Aa0cV`,
	"searchGroupContainer": `UserDetails-searchGroupContainer-lMbEu`,
	"aboutGrid": `UserDetails-aboutGrid-JkoM6`,
	"responsiveView": `UserDetails-responsiveView-dpShh`,
	"positionFive": `UserDetails-positionFive-XeZjd`,
	"positionTwo": `UserDetails-positionTwo-M29jU`,
	"responsiveContentOne": `UserDetails-responsiveContentOne-Rlyuv`,
	"positionFour": `UserDetails-positionFour-x3kX0`,
	"totalCss": `UserDetails-totalCss-CCYOh`,
	"navbar-expand-lg": `UserDetails-navbar-expand-lg-cvTgM`,
	"navbar-toggler": `UserDetails-navbar-toggler-mHQQd`,
	"positionThree": `UserDetails-positionThree-yMvgj`,
	"positionSix": `UserDetails-positionSix-RI9HH`,
	"contentOne": `UserDetails-contentOne-rvMms`,
	"padding": `UserDetails-padding-hBgun`,
	"navbar-collapse": `UserDetails-navbar-collapse-yfz0F`,
	"show": `UserDetails-show-offPv`,
	"content": `UserDetails-content-M4Y5W`,
	"mr-auto": `UserDetails-mr-auto-kGRlE`,
	"navbar-nav": `UserDetails-navbar-nav-h5Xuw`,
	"footer": `UserDetails-footer-DVaWd`,
	"responsiveNoPadding": `UserDetails-responsiveNoPadding-t7AQi`,
	"aboutContainer": `UserDetails-aboutContainer-Pzazz`,
	"noPosition": `UserDetails-noPosition-bi9l0`,
	"mobimleImg": `UserDetails-mobimleImg-kf4zW`,
	"imgWidth": `UserDetails-imgWidth-u2sZ9`,
	"gridSystem": `UserDetails-gridSystem-B6eBI`,
	"displayGrid": `UserDetails-displayGrid-v0JOb`,
	"boxInner": `UserDetails-boxInner-Hc3C7`,
	"whiteDropdown": `UserDetails-whiteDropdown-DSmsm`,
	"containerWidth": `UserDetails-containerWidth-z_98z`,
	"icon": `UserDetails-icon-Wd6tt`,
	"centerChatIcon": `UserDetails-centerChatIcon-xS9YO`,
	"iconBG": `UserDetails-iconBG-Jwo0B`,
	"textAlignCenter": `UserDetails-textAlignCenter-HXKtK`,
	"textAlignLeft": `UserDetails-textAlignLeft-X8HLb`,
	"batchIcon": `UserDetails-batchIcon-xmCRc`,
	"positionRelative": `UserDetails-positionRelative-TZffw`,
	"hiddenXs": `UserDetails-hiddenXs-VZ5E1`
};
module.exports = ___CSS_LOADER_EXPORT___;
